import React from 'react'
import Checkbox, { CheckboxProps } from './Checkbox'
import InputBase from './InputBase'

export type Option = CheckboxProps

interface CheckboxesProps {
  label: string
  options: Option[]
  required?: boolean
  name?: string
  type?: 'checkbox' | 'radio'
}

const Checkboxes: React.FC<CheckboxesProps> = (props) => {
  const { options, label, required, type = 'checkbox', name } = props
  return (
    <InputBase label={label} required={required}>
      {options.map(option => {
        return <Checkbox {...option} name={option.name ?? name} key={option.id} type={type} />
      })}
    </InputBase>
  )
}

const RadioButtons: React.FC<CheckboxesProps> = (props) => {
  return <Checkboxes {...props} type='radio' />
}

export default Checkboxes
export { RadioButtons, Checkboxes }
